import { render, staticRenderFns } from "./ChatTranslation.vue?vue&type=template&id=cb3ae9b8"
import script from "./ChatTranslation.vue?vue&type=script&lang=js"
export * from "./ChatTranslation.vue?vue&type=script&lang=js"
import style0 from "./ChatTranslation.vue?vue&type=style&index=0&id=cb3ae9b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports